import React from 'react';
import {useTranslation} from 'react-i18next';
import {LEVEL_BADGES} from '../labels';

// Badge de nivel de alerta (paleta de estados del design system). Devuelve null si el
// nivel no es CRITIC/BAD/NORMAL/GOOD: para 'goal' el level es la prioridad y para ODS el
// tipo de comparación — cada renderer decide cómo mostrar esos, nunca pasan por acá a ciegas.
export function LevelBadge({level}) {
    const {t} = useTranslation();
    const badge = LEVEL_BADGES[level];
    if (!badge) return null;
    return <span className={`alert-level-badge ${badge.className}`}>{t(badge.labelKey)}</span>;
}
